import {parseParam, replaceDynamicParameter} from '../index';
import {DYNAMIC_PARAMETER_TYPE} from '../constant';
import {
  getConfigByInstanceId,
  getRenderComponentById,
  getRenderComponentsById
} from '../../../store/common/action';
import {getFormById} from "../../../api/form_design";
import {addToMap} from "../../index";
import {getChildPropsIncludeTarget} from "../../atomicCompDataHandleFun/initViewComp";
import { showToast } from '../../popup';

/**
 * 调用自定义函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const invokeCustomFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) > 0) {
    let customParamsListCopy = [...customParamsList];
    if (_size(_get(func, 'inParams')) === 2) {
      customParamsListCopy = _cloneDeep(customParamsList);
      replaceDynamicParameter(customParamsListCopy, DYNAMIC_PARAMETER_TYPE.FUNCTION_PARAMETER, await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId));
    }
    await parseParam(_get(func, 'inParams')[0], customParamsListCopy, customFunctionParams, instanceId);
  }
};
/**
 * 参数生成对象函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const generateObjectFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  const resultObject = {};
  const inParams = _get(func, 'inParams', []);
  for (let i = 0; i < inParams.length; i += 2) {
    let key = await parseParam(inParams[i], customParamsList, customFunctionParams, instanceId);
    resultObject[key] = i + 1 < inParams.length
      ? await parseParam(inParams[i + 1], customParamsList, customFunctionParams, instanceId)
      : '';
  }
  return resultObject;

};


/**
 * 组件属性生成对象函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const generateAttrObjectFun = async (func, customParamsList, customFunctionParams, instanceId) => {
  console.log('generateAttrObjectFunction', func, customParamsList, customFunctionParams, instanceId);
  const resultObject = {};
  if (_size(_get(func, 'inParams')) > 0) {
    let componentProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    console.log('componentProp--------', componentProp);
    // 过滤系统字段
    let filterSystemField = false;
    if (_size(_get(func, 'inParams')) > 1) {
      filterSystemField = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    }
    let component: ComponentItem
    if (typeof componentProp === 'string') {
      component = getRenderComponentById(instanceId, componentProp);
    } else {
      component = componentProp
    }
    console.log("components------------------------", component);
    if (component && component.attrs) {
      for (const key in component.attrs) {
        if (component.attrs.hasOwnProperty(key)) {
          if (filterSystemField) {
            if (component.attrs[key].default) {
              resultObject[key] = component.attrs[key].value;
            }
          } else {
            resultObject[key] = component.attrs[key].value;
          }
        }
      }
    }
  }
  console.log('resultObject------------', resultObject);
  return resultObject;
};

/**
 * 收集表单数据
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const collectFormData = async (func, customParamsList, customFunctionParams, instanceId) => {
  const resultObject = {};
  const groupMap = new Map();
  const components = getRenderComponentsById(instanceId);
  components.forEach(component => {
    for (const key of Object.keys(component.attrs)) {
      // 只搜集p_开头的属性
      if (key.startsWith('p_') || key.startsWith('view_')) {
        resultObject[key] = component.attrs[key]["value"]
      }
      // 特殊处理 单选框的值会覆盖 多选需要组成结构['a','b']
      if (component.type === 'input' && ['radio', 'checkbox'].includes(component.attrs[key]['value'])) {
        // 页面存在多个单选框组情况
        addToMap(groupMap, component.attrs['name']['value'], component);
      }
    }
  })
  groupMap.forEach((compList, _) => {
    const checkboxList = []
    for (const comp of compList) {
      Object.keys(comp.attrs).forEach(key => {
        // attrs.checked.value 表示该单选按钮是选中状态
        if (_get(comp, ['attrs', 'inputType', 'value']) === 'radio' && _get(comp, "attrs.checked.value", false) === true && !resultObject[key] && key.startsWith('p_')) {
          resultObject[key] = comp.attrs[key].value;
        }
        if (_get(comp, ['attrs', 'inputType', 'value']) === 'checkbox' && _get(comp, "attrs.checked.value", false) === true && key.startsWith('p_')) {
          checkboxList.push(comp.attrs[key].value)
          resultObject[key] = checkboxList
        }
      })
    }
  });
  console.log('collectFormData resultObject------------', resultObject, func, customParamsList, customFunctionParams);
  return resultObject

}


/**
 * 生成formData对象
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const generateFormData = async (func, customParamsList, customFunctionParams, instanceId) => {
  const formData = new FormData();
  const inParams = _get(func, 'inParams', []);
  for (let i = 0; i < inParams.length; i += 2) {
    if (i + 1 < inParams.length) {
      let key = await parseParam(inParams[i], customParamsList, customFunctionParams, instanceId);
      let value = await parseParam(inParams[i + 1], customParamsList, customFunctionParams, instanceId);
      console.log("generateFormData----------", key, value);
      if (value instanceof FileList) {
        for (let j = 0; j < value.length; j++) {
          formData.append(key, value[j]);
        }
      } else {
        formData.append(key, value);
      }
    }
  }
  return formData;
};

/**
 * 生成随机字符串.
 *
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 * @returns 随机字符串.
 */
export const generateRandomString = async (func, customParamsList, customFunctionParams, instanceId) => {
  let length = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId) || 11;

  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
};

/**
 * 获取回调参数函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const getCallbackParamFunction = (func, customParamsList, customFunctionParams, instanceId) => {
  console.log('这个参数是------------getCallbackParamFunction------------', func, customParamsList, customFunctionParams, instanceId);

};

/**
 * 合并对象
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const objectAssign = async (func, customParamsList, customFunctionParams, instanceId) => {
  console.log('这个参数是------------objectAssign------------', func, customParamsList, customFunctionParams, instanceId);
  let objValue1 = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
  let objValue2 = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);

  return {...objValue1, ...objValue2};
};

/**
 * 拷贝值到鼠标事件中
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const copyToClipboard = async (func, customParamsList, customFunctionParams, instanceId) => {
  // 获取要复制的内容
  if (_size(_get(func, 'inParams')) === 1) {
    let textValue = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    await navigator.clipboard.writeText(textValue);
  }
}


/**
 * 导出数据
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const exportDataFun = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let dataSourceProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    console.log("dataSource----", dataSourceProp)
    const configTree = getConfigByInstanceId(instanceId);
    const dataSource = _get(configTree, ['dataSources', 'items']).find(item => item.prop === dataSourceProp);
    console.log("data----------", dataSource)
    const form_table = await getFormById({domainCode: dataSource.domainCode, id: dataSource.formId});
    console.log("form_table", form_table);
    //
    document.dispatchEvent(new CustomEvent('open-export-dialog', {
      detail: {
        instanceId: instanceId,
        dataSourceProp: dataSourceProp,
        column: _get(form_table, ['data', 'item', 'tables', 0, 'column']),
        label: dataSource.label,
      },
      // 可选配置：是否冒泡、是否可取消
      bubbles: true,
      cancelable: true
    }));
  }
}


/**
 * 导入数据
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const importDataFun = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let dataSourceProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    console.log("dataSource----", dataSourceProp)
    const configTree = getConfigByInstanceId(instanceId);
    const dataSource = _get(configTree, ['dataSources', 'items']).find(item => item.prop === dataSourceProp);
    console.log("data----------", dataSource)
    const form_table = await getFormById({domainCode: dataSource.domainCode, id: dataSource.formId});
    console.log("form_table", form_table);
    //
    document.dispatchEvent(new CustomEvent('open-import-dialog', {
      detail: {
        instanceId: instanceId,
        dataSourceProp: dataSourceProp,
        column: _get(form_table, ['data', 'item', 'tables', 0, 'column']),
        label: dataSource.label,
        domainCode: dataSource.domainCode,
        formId: _get(form_table, ['data', 'item', '_id'])
      },
      // 可选配置：是否冒泡、是否可取消
      bubbles: true,
      cancelable: true
    }));
  }
}


/**
 * 批量获取节点属性
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 * return 输出数组结构
 */

export const getBatchNodeAttrs = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    const filterSystemField = true
    const resultList = []
    let parentProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let childProp = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    const renderTreeMap = getRenderComponentsById(instanceId);
    const result = getChildPropsIncludeTarget(renderTreeMap, parentProp, childProp);
    if (_size(result) > 0) {
      for (const prop of result) {
        const component = getRenderComponentById(instanceId, prop);
        const resultObject = {}
        if (component && component.attrs) {
          for (const key in component.attrs) {
            if (component.attrs.hasOwnProperty(key)) {
              if (filterSystemField) {
                if (component.attrs[key].default) {
                  resultObject[key] = component.attrs[key].value;
                }
              } else {
                resultObject[key] = component.attrs[key].value;
              }
            }
          }
          resultList.push(resultObject);
        }
      }
    }
    console.log("result", resultList);
    return resultList;
  }
}

/**
 * 自定义缓存存入浏览器
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const setSessionStorageFun = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let key = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let rawValue = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    // 统一转为字符串再存入
    const saveValue = formatStorageValue(rawValue);
    sessionStorage.setItem(key, saveValue);

    return saveValue;
  }
}

const formatStorageValue = (val) => {
  // 对象/数组 用JSON序列化
  if (typeof val === 'object' && val !== null) {
    return JSON.stringify(val);
  }
  // 数字、布尔、null、undefined 统一转字符串
  return String(val);
};

/**
 * 获取浏览器缓存
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const getSessionStorageFun = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let key = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    const strVal = sessionStorage.getItem(key);
    if (strVal === null) return null;
    try {
      return JSON.parse(strVal);
    } catch {
      return strVal;
    }
  }
}

/**
 * 弹出提示框
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const popUpAlertBoxFun = async (func, customParamsList, customFunctionParams, instanceId) => {

  let strVal1 = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);

  if (_size(_get(func, 'inParams')) > 1) {
    let strVal2 = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);

    if(strVal2 == "成功" || strVal2 == "success"){
      showToast(strVal1, 'success');
    }else if(strVal2 == "错误" || strVal2 == "error"){
      showToast(strVal1, 'error');
    }else if(strVal2 == "警告" || strVal2 == "warn"){
      showToast(strVal1, 'warn');
    }else{
      showToast(strVal1, 'info');
    }
  }else{
    showToast(strVal1, 'info');
  }


}
